import { Link } from "react-router-dom";
import { motion } from "framer-motion";

// Alle Platzhalter in [eckigen Klammern] bitte vor Veröffentlichung ersetzen.
const Section = ({ title, children }) => (
  <section className="mt-14">
    <h2 className="font-display font-bold uppercase tracking-tight text-xl md:text-2xl text-[#f5f3ef]">{title}</h2>
    <div className="mt-5 text-sm md:text-base text-[#a3a3ac] font-light leading-relaxed space-y-3">{children}</div>
  </section>
);

export default function Impressum() {
  return (
    <main data-testid="impressum-page" className="min-h-screen bg-[#070709] text-[#f5f3ef] px-6 md:px-16 py-28">
      <div className="noise-page grain" />
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="max-w-3xl mx-auto"
      >
        <p className="font-mono2 text-[10px] tracking-[0.4em] text-[#64646e] uppercase">TONE — RECHTLICHES</p>
        <h1 className="font-display font-extrabold uppercase tracking-[-0.05em] leading-none text-[7vw] sm:text-[2.6rem] lg:text-6xl mt-4">
          IMPRES<span className="text-[#70c7fa]">SUM</span>
        </h1>
        <p className="mt-6 font-mono2 text-[11px] tracking-[0.25em] text-[#38bdf8] uppercase">
          Angaben gemäß § 5 DDG (vormals § 5 TMG)
        </p>

        <Section title="Diensteanbieter">
          <p>
            Toni Sven Beier
            <br />
            In der Lohe 4
            <br />
            90765 Fürth
            <br />
            Deutschland
          </p>
        </Section>

        <Section title="Kontakt">
          <p>
            E-Mail:{" "}
            <a href="mailto:info@tonesound.de" className="text-[#70c7fa] hover:underline">
              info@tonesound.de
            </a>
          </p>
        </Section>

        <Section title="Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV">
          <p>
            Toni Sven Beier
            <br />
            In der Lohe 4, 90765 Fürth
          </p>
        </Section>

        <Section title="Haftung für Inhalte">
          <p>
            Die Inhalte dieser Website wurden mit großer Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und
            Aktualität der Inhalte wird keine Gewähr übernommen. Als Diensteanbieter bin ich gemäß § 7 Abs. 1 DDG für
            eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
          </p>
        </Section>

        <Section title="Haftung für Links">
          <p>
            Diese Website enthält Links zu externen Websites Dritter (z. B. Instagram, Streaming-Plattformen), auf
            deren Inhalte kein Einfluss besteht. Für die Inhalte der verlinkten Seiten ist stets der jeweilige
            Anbieter oder Betreiber der Seiten verantwortlich.
          </p>
        </Section>

        <Section title="Urheberrecht">
          <p>
            Die auf dieser Website veröffentlichten Inhalte, Werke, Musik, Texte und Bilder unterliegen dem deutschen
            Urheberrecht. Jede Verwertung außerhalb der Grenzen des Urheberrechts bedarf der vorherigen schriftlichen
            Zustimmung des jeweiligen Rechteinhabers.
          </p>
        </Section>

        <p className="mt-16 font-mono2 text-[10px] tracking-[0.25em] text-[#64646e] uppercase leading-relaxed">
          Stand: September 2026
        </p>

        <Link
          data-testid="impressum-back-link"
          to="/"
          className="inline-block mt-10 font-mono2 text-[10px] tracking-[0.3em] text-[#64646e] hover:text-[#70c7fa] uppercase transition-colors"
        >
          ← Zurück zur Website
        </Link>
      </motion.div>
    </main>
  );
}
